export function debounce(func, timeout = 300) {
	let timer;
	return (...args) => {
		clearTimeout( timer );
		timer = setTimeout(
			() => {
            func.apply( this, args );
			},
			timeout
		);
	};
}

export function getChildrenHeight(el) {
	let height = 0;

	Array.from( el.children ).forEach(
		(child) => {
			height += child.offsetHeight;
		}
	)

	return height;
}

export function getChildrenWidth(el) {
	let width = 0;

	Array.from( el.children ).forEach(
		(child) => {
			width += child.offsetWidth;
		}
	)

	return width;
}

export function slideDown(el, animationTime = 300) {
	el.style.maxHeight     = getChildrenHeight( el ) + 'px';
	setTimeout(
		() => {
			el.style.maxHeight = 'unset';
		},
		animationTime
	)
}

export function slideUp(el) {
	el.style.maxHeight = getChildrenHeight( el ) + 'px';
	setTimeout(
		() => {
			el.style.removeProperty( 'max-height' );
		},
		10
	)
}

export function slideFromTo(el, fromHeight, toHeight, animationTime = 300) {
	el.style.height    = '99999px'
	el.style.maxHeight = fromHeight + 'px'

	if (typeof toHeight === "number") {
		setTimeout(
			() => {
				el.style.maxHeight = toHeight + 'px'
				if (typeof animationTime === "number") {
					setTimeout(
						() => {
							el.style.removeProperty( 'height' )
							el.style.maxHeight = 'unset'
						},
						animationTime
					)
				}
			},
			10
		)
	}
}

export function slideRight(el, animationTime = 300) {
	el.style.maxWidth = getChildrenWidth( el ) + 'px';
	if (typeof animationTime === "number") {
		setTimeout(
			() => {
				el.style.maxWidth = 'unset';
			},
			animationTime
		)
	}
}

export function slideWidthFromTo(el, fromWidth, toWidth, animationTime = 300, unset = true) {
	el.style.width    = '99999px'
	el.style.maxWidth = fromWidth + 'px'

	if (typeof toWidth === "number") {
		setTimeout(
			() => {
				el.style.maxWidth = toWidth + 'px'
				if (typeof animationTime === "number" || animationTime === null) {
					setTimeout(
						() => {
							el.style.removeProperty( 'width' )
							if (unset) {
								el.style.maxWidth = 'unset'
							} else {
								el.style.removeProperty( 'max-width' )
							}
						},
						animationTime || 300
					)
				}
			},
			10
		)
	}
}

export function mapStyles() {
	return [
	{
		"featureType": "all",
		"elementType": "labels.text.fill",
		"stylers": [
		{
			"color": "#666c99"
		}
		]
	},
	{
		"featureType": "all",
		"elementType": "labels.text.stroke",
		"stylers": [
		{
			"color": "#c2c8f4"
		}
		]
	},
	{
		"featureType": "administrative.country",
		"elementType": "geometry.fill",
		"stylers": [
		{
			"color": "#ff0000"
		},
		{
			"visibility": "on"
		}
		]
	},
	{
		"featureType": "administrative.country",
		"elementType": "geometry.stroke",
		"stylers": [
		{
			"weight": "2.00"
		},
		{
			"color": "#959abf"
		}
		]
	},
	{
		"featureType": "administrative.province",
		"elementType": "geometry.stroke",
		"stylers": [
		{
			"color": "#a3a9d6"
		},
		{
			"weight": "3.00"
		}
		]
	},
	{
		"featureType": "landscape.man_made",
		"elementType": "all",
		"stylers": [
		{
			"visibility": "off"
		}
		]
	},
	{
		"featureType": "landscape.natural.landcover",
		"elementType": "all",
		"stylers": [
		{
			"saturation": "0"
		},
		{
			"lightness": "0"
		}
		]
	},
	{
		"featureType": "landscape.natural.landcover",
		"elementType": "geometry.fill",
		"stylers": [
		{
			"color": "#c2c8f4"
		}
		]
	},
	{
		"featureType": "landscape.natural.terrain",
		"elementType": "all",
		"stylers": [
		{
			"visibility": "off"
		}
		]
	},
	{
		"featureType": "poi",
		"elementType": "all",
		"stylers": [
		{
			"visibility": "off"
		}
		]
	},
	{
		"featureType": "road",
		"elementType": "all",
		"stylers": [
		{
			"visibility": "off"
		}
		]
	},
	{
		"featureType": "water",
		"elementType": "geometry.fill",
		"stylers": [
		{
			"color": "#a0aedc"
		}
		]
	}
	];
}

export function addInitMap(func) {
	if (typeof window.initMap !== 'function') {
		window.initMap = function () {
			if (typeof window.initMap.functions.forEach === 'function') {
				window.initMap.functions.forEach( f => f() )
			}
		}
	}

	if (typeof window.initMap.functions !== 'object') {
		window.initMap.functions = []
	}

	if (typeof func === 'function') {
		window.initMap.functions.push( func )
	} else {
		console.error( func, 'is not a function!' )
	}
}


export function isVisible(element) {
  if(element){
	  const rect = element.getBoundingClientRect();
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }
}